import { z } from "zod";
import { apiListSchema } from "./list";
//? DTO
export const CreateTourServiceDtoSchema = z.object({
  TourId: z.number(),
  ServiceId: z.number(),
  Day: z.number(),
  Hour: z.string(),
  Order: z.number().nullish(),
  ServiceProviderId: z.number().nullish(),
});

export type CreateTourServiceDto = z.infer<typeof CreateTourServiceDtoSchema>;

export const TourServiceDtoSchema = CreateTourServiceDtoSchema.extend({
  Id: z.number(),
});
export type TourServiceDto = z.infer<typeof TourServiceDtoSchema>;

export const tourServiceDtoListSchema = apiListSchema(TourServiceDtoSchema);

//? Model
export const CreateTourServiceSchema = z.object({
  tourId: z.number(),
  serviceId: z.number(),
  day: z.number(),
  startHour: z.string(),
  endHour: z.string(),
  order: z.number(),
  serviceProviderId: z.number().nullish(),
});

export const TourServiceSchema = CreateTourServiceSchema.extend({
  id: z.string().min(1),
});

export type CreateTourService = z.infer<typeof CreateTourServiceSchema>;

export type TourService = z.infer<typeof TourServiceSchema>;

//? Mappers
export function tourServiceFromDto(dto: TourServiceDto): TourService {
  const [startHour, endHour] = dto.Hour.split("|");
  return {
    id: dto.Id.toString(),
    tourId: dto.TourId,
    serviceId: dto.ServiceId,
    day: dto.Day,
    endHour,
    startHour,
    order: dto.Order ?? 0,
    serviceProviderId: dto.ServiceProviderId,
  };
}

export function tourServiceToDto(dto: TourService): TourServiceDto {
  return {
    Id: Number.parseInt(dto.id),
    ...createTourServiceToDto(dto),
  };
}

export function createTourServiceToDto(
  dto: CreateTourService
): CreateTourServiceDto {
  return {
    Day: dto.day,
    ServiceId: dto.serviceId,
    Hour: `${dto.startHour}|${dto.endHour}`,
    TourId: dto.tourId,
    Order: dto.order,
    ServiceProviderId: dto.serviceProviderId,
  };
}
